import Sales from "../../../services/sales";
import { phone } from "../../../filters/string";
import Contracts from "../../../services/contracts";
import Auth from "../../../services/auth";
import { centss } from "../../../filters/number";
import * as Utils from "../../../utils";
import C from "../../common/constantes";
import messageDialog from "../../../components/message-dialog.vue";
import ChoosePayment from "../../account/vehicle/choose-payment.vue";
import { date } from "../../../filters/date";

export default {
  props: ["value", "hideIncrement"],
  data() {
    return {
      loading: undefined,
      contract: undefined,
      rechargeValue: undefined,
      currentValue: "",
      rate: 0,
      credit: 0,
      user: Auth.currentUser,
      step: 0,
      contractPaymentMethodId: undefined,
      msgError: undefined,
      cvv: undefined,
      expirationDate: undefined,
      disabledButton: true,
    };
  },
  computed: {
    getValue() {
      if (this.currentValue || this.currentValue == 0)
        return centss(this.currentValue);

      return "";
    },
    contractId: function () {
      return this.contract.contractId;
    },
    planId() {
      return this.contract.plan.planId;
    },
    typesAllowed() {
      return this.$store.getters.getPaymentsTypesByPlan(this.planId);
    },
    paymentMethodBankBill() {
      return this.$store.getters
        .getPlanById(this.planId)
        .paymentMethod.paymentMethod.find((e) => e.paymentMethodId == 106);
    },
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    },
  },
  methods: {
    putCvv(p) {
      this.cvv = p;
    },
    calculateRecharge: _.debounce(function () {
      let promise = Sales.calculateRechargeRate({
        value: this.currentValue,
        planId: this.contract.plan.planId,
        contractId: this.contract.contractId,
      })
        .then((resp) => {
          this.rate = resp.taxTotal;
          this.credit = resp.valueTotal;

          this.disabledButton = false;
        })
        .catch((err) => {
          this.rate = "N/A";
          this.credit = 0;
        });
      this.$store.dispatch("loading", promise);
    }, 600),
    doRecharge() {
      this.msgError = undefined;
      if (this.credit == 0) {
        messageDialog.show({
          title: "Aviso",
          headerClass: "modal-danger",
          message: "Valor de recarga inválido",
        });
        return;
      }
      if (
        this.unit == -1 &&
        (!this.rechargeValue ||
          parseInt(this.rechargeValue) < parseInt(this.minValue))
      ) {
        this.msgError = `Valor de recarga inválido`;

        return false;
      }
      if (!this.contractPaymentMethodId) {
        this.msgError = `Selecione a forma de pagamento`;

        return false;
      }

      let request = {
        recharge: {
          contractId: this.contractId,
          contractPaymentMethod: this.$refs.choosePayment.getPaymentSelected(),
          secureCode: this.user.taxIdNumber.substring(0, 4),
          value: this.currentValue,
          expirationDate: date(this.expirationDate),
          _interface: window.document.webview ? "MOBILE" : "WEBSITE",
        },
      };

      let promise = Sales.recharge(request)
        .then((resp) => {
          this.showMessage(resp);
        })
        .catch((err) => {
          this.showMessage(err.data);
        });
      this.$store.dispatch("loading", promise);
      return promise;
    },
    showMessage(resp) {
      let code = resp.status.code;
      if (code == 0) {
        let msg =
          "A recarga será disponibilizada na conta Move Mais após a confirmação de pagamento.";
        if (resp.boletoUrl) {
          window.open(resp.boletoUrl);
          msg += `<br><div class='text-center margin-20'><a href='${resp.boletoUrl}' class='btn btn-primary' target='_blank'>Imprimir Boleto</a><br></div><small>Caso não consiga visualizar o boleto verifique seu bloqeuador de popup.</small>`;
        }
        messageDialog
          .show({
            title: "Recarga realizada com sucesso",
            headerClass: "modal-success",
            message: msg,
          })
          .then((res) => {
            this.$router.push({
              name: "requests",
            });
          });
        return;
      } else {
        let msg =
          "Ocorreu um problema e não foi possível concluir sua recarga, por favor entre em contato com a Central de Atendimento.";
        switch (code) {
          case 9991:
            msg =
              "Não foi possível confirmar o pagamento da sua recarga, por favor verifique os dados do seu cartão.";
            break;
          case 9992:
          case 9993:
            msg = resp.status.message;
        }
        messageDialog
          .show({
            title: "Erro",
            headerClass: "modal-danger",
            message: msg,
          })
          .then((res) => {
            if (code == 9993) {
              this.$router.push({
                name: "requests",
              });
            }
          });
      }
    },
    nextStep() {
      this.msgError = undefined;
      $("body").stop().animate(
        {
          scrollTop: 0,
        },
        "500",
        "swing",
      );
      switch (this.step) {
        case 0:
          if (this.credit == 0) {
            messageDialog.show({
              title: "Aviso",
              headerClass: "modal-danger",
              message: "Valor de recarga inválido",
            });
            return;
          }
          this.step += 1;
          break;
        case 1:
          this.step += 1;
          break;
      }
    },
    backStep() {
      if (this.step == 0) {
        this.cancelar();
        return;
      }

      this.msgError = undefined;
      $("body").stop().animate(
        {
          scrollTop: 0,
        },
        "500",
        "swing",
      );
      this.step -= 1;
    },
    cancelar() {
      messageDialog
        .show({
          title: "Cancelar compra de créditos",
          message: "Deseja cancelar a compra de créditos?",
          type: "OK-CANCEL-ADHESION",
        })
        .then((res) => {
          if (res == "OK") {
            this.$router.push({
              name: "plans",
            });
          }
        });
    },
    doRequest() {
      // this.$refs.summary.validateAll().then(r => {
      //   let promise = Sales.adhesion(this.request).then(r => {
      //     this.code = r.status.code;
      //     this.boletoUrl = r.boletoUrl;
      //     $('body').stop().animate({
      //       scrollTop: 0
      //     }, '500', 'swing');
      messageDialog
        .show({
          title: "Comprar créditos",
          message: "Compra concluida com sucesso!",
          type: "OK",
        })
        .then((res) => {
          if (res == "OK") {
            this.$router.push({
              name: "plans",
            });
          }
        });
      //   }).catch(err => {
      //     this.msgError = err.data.status.message;
      //     this.code = err.data.status.code;
      //     $('body').stop().animate({
      //       scrollTop: 0
      //     }, '500', 'swing');
      //   });
      //
      //   this.$store.dispatch('loading', promise);
      //
      // });
    },
    goToStep(value) {
      this.code = undefined;
      this.step = value;
    },
    alterValue(value) {
      this.disabledButton = true;

      let newValue = this.currentValue + value;

      if (newValue < 0) return false;

      this.setValue("" + newValue);
    },
    setValue(newValue) {
      this.disabledButton = true;
      if (!Number.isNaN(newValue) && newValue != "") {
        this.currentValue = parseInt(newValue.replace(/[^0-9]/g, ""));
        this.$emit("input", this.currentValue);
        this.calculateRecharge();
      } else {
        this.currentValue = newValue;
        this.$emit("input", undefined);
      }
    },
  },
  mounted() {
    let moveMaisId = Auth.currentUser.moveMaisId;
    this.loading = Contracts.findAll(moveMaisId).then((response) => {
      this.contract = _.find(response, function (o) {
        return o.plan.planId == 6;
      });
    });
  },
  components: {
    ChoosePayment,
  },
};



// WEBPACK FOOTER //
// ./src/pages/account/toll-ticket/buy-credit.js